import React from "react";
import { products } from "./Products";
import { useCart } from "./CartContext";

const AllProducts = () => {
  const { addToCart } = useCart();

  return (
    <section style={{ background: "#ffffff" }} className="py-5">
      <div className="container">
        <h2 className="text-center fw-bold mb-2"
          style={{
            color: '#2c2c2c',
            fontFamily: "'Playfair Display',serif",
            letterSpacing: '.025em',
            fontSize: "1.28rem"
          }}>
          Premium Hair Products
        </h2>
        <p className="text-center text-muted mb-3" style={{
          fontWeight: 400,
          fontSize: ".97rem",
          maxWidth: 450,
          margin: "0 auto"
        }}>
          Maintain salon-style perfection between visits with our professional-grade hair care collection.
        </p>
        <div
          className="row g-2 justify-content-center"
          style={{ rowGap: '0.7rem', columnGap: '0.95rem' }}
        >
          {products.map((product) => (
            <div
              key={product.id}
              className="col-6 col-md-4 col-lg-3 d-flex flex-column align-items-center"
              style={{
                minWidth: 145,
                maxWidth: 190,
                margin: '0 auto',
                padding: 0
              }}
            >
              <div
                className="w-100"
                style={{
                  background: "#fff",
                  borderRadius: 8,
                  boxShadow: "0 2px 7px #cab38a19",
                  padding: 0,
                  transition: "transform .16s, box-shadow .17s",
                  overflow: "hidden",
                  height: 265,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end"
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: 110,
                    borderTopLeftRadius: 8,
                    borderTopRightRadius: 8,
                    overflow: "hidden",
                    background: "#fff",
                  }}
                >
                  <img
                    src={product.image}
                    alt={product.alt}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block"
                    }}
                    onError={e => {
                      if (!e.target.dataset.fallback) {
                        e.target.dataset.fallback = "true";
                        e.target.src = "/placeholder-image.jpg";
                      }
                    }}
                  />
                </div>
                <div
                  style={{
                    padding: '10px 8px 4px 8px',
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    flexGrow: 1,
                    justifyContent: "center",
                    width: "100%"
                  }}
                >
                  <div style={{
                    fontSize: ".97em",
                    fontWeight: 700,
                    color: "#332b16",
                    fontFamily: "Inter,sans-serif",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    textAlign: "center",
                    width: "100%"
                  }}>
                    {product.title}
                  </div>
                  <div style={{
                    fontSize: ".92em",
                    color: "#87744f",
                    margin: "3px 0 7px 0",
                    textAlign: "center",
                    height: "38px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    width: "100%"
                  }}>
                    {product.description}
                  </div>
                  <div style={{
                    color: "#2c2c2c",
                    fontWeight: 700,
                    fontSize: ".99em",
                    textAlign: "center",
                    marginBottom: 2
                  }}>
                    {product.price > 0 ? <>R {product.price}</> : <span className="text-danger fs-6 fw-normal">Unavailable</span>}
                  </div>
                  <button
                    className="btn rounded-pill w-100 fw-bold mt-2"
                    style={{
                      background: product.price > 0 ? "linear-gradient(90deg,#c4a15a,#d4c4a8)" : "#ddd",
                      color: product.price > 0 ? "#fff" : "#999",
                      fontSize: ".965em",
                      border: "none",
                      fontFamily: "Inter,sans-serif",
                      letterSpacing: ".01em",
                      cursor: product.price > 0 ? "pointer" : "not-allowed",
                      minHeight: 32
                    }}
                    disabled={product.price === 0}
                    onClick={() => addToCart(product.id)}
                  >
                    {product.price === 0 ? "Unavailable" : "Add to Cart"}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AllProducts;
